/**
 * We'll load jQuery and all the plugins.
 * Honestly... This Laravel mix sucks, but we don't have a kubernetes cluster to make things properly
 */
try {
    window.$ = window.jQuery = require('jquery');
    require('bootstrap');
    require('jquery-match-height');
    require('scrollspy');
    require('./scripts');
} catch (e) {
    console.log(e);
}
